// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3vpIp","row":"ProcedureTreatmentSummary_row__3PvGz"};